import React, { useState } from 'react';

const careerHistory = [
  { date: 'Oct 2024', title: 'Marketing Engineer and Solution Engineer' },
  { date: 'Nov 2023 - Sep 2024', title: 'CRM manager and Data Management' },
  { date: 'Aug 2020 - Oct 2023', title: 'CRM/BI lead' },
  { date: 'Feb 2020 - Jul 2023', title: 'Data Management Specialist' },
  { date: 'May 2011 - Jan 2020', title: 'Specialist/Campaign Specialist/CRM lead' },
  { date: 'Sep 2008 - Apr 2011', title: 'Project Team Member' },
];

const CareerTimelineItem = ({ entry, isLast }) => (
  <li className="relative">
    {!isLast && (
      <div
        className="absolute top-5 left-[11px] -ml-px mt-0.5 h-full w-0.5 bg-gray-700"
        aria-hidden="true"
      ></div>
    )}
    <div className="relative flex items-start group">
      <span className="h-9 flex items-center" aria-hidden="true">
        <span className="relative z-10 w-6 h-6 flex items-center justify-center bg-gray-800 rounded-full ring-4 ring-[#18181B] group-hover:bg-cyan-500 transition-colors duration-300">
          <span className="h-2.5 w-2.5 bg-gray-500 rounded-full group-hover:bg-cyan-300 transition-colors duration-300"></span>
        </span>
      </span>
      <div className="ml-4 md:ml-6 flex-1 pt-1">
        <p className="text-sm font-medium text-gray-400">{entry.date}</p>
        <h3 className="text-lg font-semibold text-gray-100 mt-1">{entry.title}</h3>
      </div>
    </div>
  </li>
);

const Career = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const ITEMS_TO_SHOW_COLLAPSED = 3;

  const visibleHistory = isExpanded
    ? careerHistory
    : careerHistory.slice(0, ITEMS_TO_SHOW_COLLAPSED);

  return (
    <div className="bg-[#18181B] border border-gray-700 rounded-2xl shadow-xl p-8 sm:p-12">
      <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 mb-6">
        Career Journey
      </h2>
      <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-12">
        With over 15 years of experience spanning CRM systems, data management,
        and marketing automation, I specialize in bridging the gap between business strategy and technical implementation.
        My career journey has included leading roles in CRM/BI, Salesforce-based solution engineering, and cross-platform campaign automation.
        Whether managing data pipelines, developing custom solutions, or enabling global teams through scalable infrastructure,
        my passion lies in optimizing operations with a tech-savvy, user-centered approach. Please visit my <a href="https://www.linkedin.com/in/megumimizuno/" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:text-sky-300 hover:underline">LinkedIn</a> for more details.
      </p>

      <ul className="space-y-8">
        {visibleHistory.map((entry, index) => (
          <CareerTimelineItem
            key={index}
            entry={entry}
            isLast={index === visibleHistory.length - 1}
          />
        ))}
      </ul>

      {careerHistory.length > ITEMS_TO_SHOW_COLLAPSED && (
        <div className="mt-10 text-center">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="inline-flex items-center justify-center px-6 py-3 border border-gray-600 text-base font-medium rounded-full text-cyan-200 bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 focus:ring-offset-gray-900 transition-all shadow-md hover:shadow-cyan-500/10"
            aria-expanded={isExpanded}
          >
            {isExpanded ? 'Show Less' : 'View Full Journey'}
            <svg
              className={`ml-2 h-5 w-5 transform transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Career;
